import Api from '~/api'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'
import { resetForm, formSuccess, isLoading, formError } from '~/form/actions'

export function createContact(formId, contact, onSubmit) {
  return (dispatch, getState) => {
    Api.post('/contact', { contact })
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(createContactSuccess(data.item))
          dispatch(resetForm(formId))
        }

        if (data.message) dispatch(formError(formId, { messages: fromJS([data.message]) }))
      })
      .catch(err => dispatch(formError(formId, { messages: [err.message || 'Error when creating contact'] })))
  }
}

export function createContactSuccess(item) {
  return {
    type: 'CONTACT_CREATE_SUCCESS',
    table_id: 'contacts',
    item,
  }
}

/* Edit person */

export function editContact(formId, id, values) {
  return (dispatch, getState) => {
    Api.patch(`/contact/${id}`, { values })
      .then(({ data = {} }) => {
        if (data.success) {
          dispatch(editContactSuccess(data.item))
          dispatch(resetForm(formId))
        }

        if (data.message) dispatch(formError(formId, { messages: fromJS([data.message]) }))
      })
      .catch(err => {
        console.log(err)
        dispatch(formError(formId, { messages: fromJS([err.message || 'Error when editing contact']) }))
      })
      .finally(() => dispatch(isLoading(formId, false)))
  }
}

export function editContactLoading(loading) {
  return {
    type: 'CONTACT_EDIT_LOADING',
    loading,
  }
}

export function editContactSuccess(item) {
  return {
    type: 'CONTACT_EDIT_SUCCESS',
    table_id: 'contacts',
    item,
  }
}

export function editContactError(message) {
  return {
    type: 'CONTACT_EDIT_ERROR',
    message,
  }
}

/* Fetch contacts */

export function fetchContacts(config = {}) {
  return dispatch => {
    dispatch(fetchContactsLoading(true))
    Api.get('/contact', config)
      .then(({ data }) => {
        if (data.success) return dispatch(fetchContactsSuccess(data.items))

        if (data.message) return dispatch(fetchContactsError(data.message))
      })
      .finally(() => dispatch(fetchContactsLoading(false)))
  }
}

export function fetchContactsLoading(loading = true) {
  return {
    type: 'CONTACTS_FETCH_LOADING',
    loading,
  }
}

export function fetchContactsSuccess(items) {
  return {
    type: 'CONTACTS_FETCH_SUCCESS',
    items,
  }
}

export function fetchContactsError(message) {
  return {
    type: 'CONTACTS_FETCH_ERROR',
    message,
  }
}

/* Attach contact */
export function attachContact(data) {
  return (dispatch, getState) => {
    Api.post('/contact/attach', data)
      .then(({ data = {} }) => {
        if (data.success) dispatch(attachContactSuccess(data.item))

        if (data.message) dispatch(attachContactError(data.message))
      })
      .catch(err => {
        console.log(err)
        dispatch(attachContactError(err.message || 'Error when attaching contact'))
      })
  }
}

export function attachContactLoading(loading) {
  return {
    type: 'CONTACT_ATTACH_LOADING',
    loading,
  }
}

export function attachContactSuccess(item) {
  return {
    type: 'CONTACT_ATTACH_SUCCESS',
    item,
  }
}

export function attachContactError(message) {
  return {
    type: 'CONTACT_ATTACH_ERROR',
    message,
  }
}

/* Deattach contact */
export function deattachContact(contact_id, target, target_id) {
  return (dispatch, getState) => {
    let data = {
      contact_id,
      [target]: target_id,
    }
    Api.post('/contact/deattach', data)
      .then(({ data = {} }) => {
        if (data.success) dispatch(deattachContactSuccess(data.item, data.target))

        if (data.message) dispatch(deattachContactError(data.message))
      })
      .catch(err => {
        console.log(err)
        dispatch(deattachContactError(err.message || 'Error when attaching contact'))
      })
  }
}

export function deattachContactLoading(loading) {
  return {
    type: 'CONTACT_DEATTACH_LOADING',
    loading,
  }
}

export function deattachContactSuccess(item, target = {}) {
  return {
    type: 'CONTACT_DEATTACH_SUCCESS',
    item,
    target,
  }
}

export function deattachContactError(message) {
  return {
    type: 'CONTACT_DEATTACH_ERROR',
    message,
  }
}
